import { render, staticRenderFns } from "./CardPager.vue?vue&type=template&id=7deffa58"
import script from "./CardPager.vue?vue&type=script&lang=js"
export * from "./CardPager.vue?vue&type=script&lang=js"
import style0 from "./CardPager.vue?vue&type=style&index=0&id=7deffa58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports